// Default values for the AnalyticsReporter constructor
export const defaultAnalyticsConfig = {
    clientId: '',
    inProduction: true,
    useCookies: 'newCookies',
    memoizeCookieID: true,
    maxPageLength: 512,
    version: '',
    locale: '',
    namespace: '',
    pageviewtoken: '',
    stripeCookiesEnforcementMode: undefined,
    sessionization: false,
    sessionizationDomain: '.stripe.com'
};
// Analytics Event Logger Endpoint
export const prodUrl = 'https://r.stripe.com/0';
export const qaUrl = 'https://qa-r.stripe.com/0';
// Analytics Event Logger Batched Endpoint
export const batchProdUrl = 'https://r.stripe.com/b';
export const batchQaUrl = 'https://qa-r.stripe.com/b';

//# sourceMappingURL=types.js.map